<template>
  <div>
    <section v-on:keyup.enter="loginUser">
      <mdb-row>
        <mdb-col md="5" class="m-0 p-0 grey">
          <mdb-modal cascade tabs>
            <mdb-tab tabs justify class="deep-purple darken-4">
              <mdb-tab-item :active="tabs == 1" @click.native.prevent="tabs = 1"
                ><mdb-icon icon="user" class="mr-1" />{{
                  $t("login")
                }}</mdb-tab-item
              >
              <mdb-tab-item :active="tabs == 2" @click.native.prevent="tabs = 2"
                ><mdb-icon icon="user-plus" class="mr-1" />{{
                  $t("signin")
                }}</mdb-tab-item
              >
            </mdb-tab>
            <mdb-modal-body class="mx-3" v-if="tabs == 1">
              <mdb-input
                :label="$t('email')"
                icon="envelope"
                type="email"
                class="mb-5"
                v-model="name"
              />
              <mdb-input
                :label="$t('password')"
                icon="lock"
                type="password"
                v-model="password"
              />
              <div class="mt-2 text-center">
                <mdb-btn block color="indigo" @click="loginUser"
                  >{{ $t("login") }}<mdb-icon icon="sign-in-alt" class="ml-1"
                /></mdb-btn>
              </div>
            </mdb-modal-body>
            <mdb-modal-footer center v-if="tabs == 1">
              <div class="options text-center text-md-right mt-1">
                <p>
                  {{ $t("not_registered_yet") }}
                  <a href="#" @click="tabs = 2">{{ $t("signin") }}</a>
                </p>
                <p>
                  {{ $t("forgot") }}
                  <a @click="forgotPasswordRequest" href="#">{{
                    $t("forgot_password")
                  }}</a>
                </p>
              </div>
            </mdb-modal-footer>
            <mdb-modal-body class="mx-3" v-if="tabs == 2">
              <mdb-input
                :label="$t('email')"
                icon="envelope"
                type="email"
                class="mb-5"
                v-model="name"
              />
              <mdb-input
                :label="$t('password')"
                icon="lock"
                type="password"
                class="mb-5"
                v-model="password"
              />
              <mdb-input
                :label="$t('repeat_password')"
                icon="lock"
                type="password"
                v-model="passwordrepeat"
              />
              <mdb-input
                :label="$t('retailerkey')"
                icon="key"
                type="text"
                v-model="key"
              />
              <div class="mt-2 text-center">
                <mdb-btn color="indigo" @click="signUp"
                  >{{ $t("signin") }}<mdb-icon icon="sign-in-alt" class="ml-1"
                /></mdb-btn>
              </div>
            </mdb-modal-body>
            <mdb-modal-footer center v-if="tabs == 2">
              <div class="options text-center text-md-right mt-1">
                <p>
                  {{ $t("already_member") }}
                  <a href="#" @click="tabs = 1">{{ $t("login") }}</a>
                </p>
              </div>
            </mdb-modal-footer>
          </mdb-modal>
        </mdb-col>
      </mdb-row>
    </section>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbModal,
  mdbModalBody,
  mdbTab,
  mdbTabItem,
  mdbModalFooter,
  mdbIcon,
} from "mdbvue";
export default {
  name: "RegisterLogin",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbTab,
    mdbTabItem,
    mdbModalFooter,
    mdbIcon,
  },
  data() {
    return {
      name: "",
      password: "",
      passwordrepeat: "",
      key: "",
      postdata: {},
      signuppath: "/1.0/front/securesession/createuser",
      loginpath: "/1.0/front/securesession/authenticateuser",
      forgotpasswordpath: "/1.0/newbe/forgotpassword",
      tabs: 1,
    };
  },
  methods: {
    validateName(name) {
      var re =
        /^(([a-zA-Z]|[0-9])|([-]|[_]|[.]))+[@](([a-zA-Z0-9])|([-])){2,63}[.](([a-zA-Z0-9]){2,63})+$/gi;
      return re.test(name);
    },
    validatePassword(password) {
      var re = /^.{8,}$/;
      return re.test(password);
    },
    signUp() {
      if (this.password.localeCompare(this.passwordrepeat) !== 0) {
        this.$notify.error({
          message: this.$t("register_password_mismatch"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutshort,
        });
        return;
      }
      this.postdata = JSON.stringify({
        name: this.name,
        password: this.password,
        key: this.key,
      });

      this.$http
        .post(this.signuppath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$emit("signup-successful");
            this.$store.commit("updateName", response.data.name);
            this.$notify.success({
              message: this.$t("login_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.tabs = 1;
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("login_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    forgotPasswordRequest() {
      this.$notify.success({
        message: "NOT IMPLEMENTED",
        position: "top right",
        timeOut: this.$store.state.notifytimeoutshort,
      });
    },
    forgotPassword(name) {
      this.postData = JSON.stringify({
        name: name,
      });

      this.$http
        .post(this.forgotpasswordpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("forgot_password_request_successful"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("login_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    loginUser() {
      var _self = this;
      this.postdata = JSON.stringify({
        name: this.name,
        password: this.password,
      });

      this.$http
        .post(this.loginpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$emit("login-successful");
            this.$store.commit("updateName", response.data.name);
            this.$store.commit("updateToken", response.data.token);
            _self.$http.defaults.headers["token"] = response.data.token;
            _self.$http.defaults.headers["name"] = response.data.name;
            this.$notify.success({
              message: this.$t("login_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("login_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
};
</script>
<style lang="">
</style>